/* eslint-disable max-len, camelcase */
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  data() {
    return {
      isOpenConfiguration: false,
      isOpenModalTitle: false,
      isOpenModalField: false,
      showModalExternalUrl: false,
      idConfiguration: 'listConfiguration',
      idModalFieldLibrary: 'modalFieldLibrary',
      idModalTitle: 'modalTitle',
      idModalField: 'modalField',
      selectedField: null,
      selectedIndexConfigField: null,
    };
  },

  computed: {
    ...mapState('jStoreFormUi', ['form_data_detail']),
    ...mapState('jStoreExperienceManagerV2', ['showModalFieldLibrary', 'isShowModalFieldFromGroup', 'showModalExternalApi']),
  },

  watch: {
    isOpenConfigBlock(val) {
      if (val) {
        if (this.isOpenModalTitle) this.toggleModalTitle(false);
        if (this.isOpenModalField) this.toggleModalField(false);
        if (this.isOpenConfiguration) this.toggleConfiguration(false);
      }
    },

    showModalExternalApi(val) {
      if (val) {
        this.$refs.modalExternalApi.show();
        this.showModalExternalUrl = true;
      } else {
        this.$refs.modalExternalApi.hide();
        this.showModalExternalUrl = false;
      }
    },

    formDetail(val) {
      if (!val.form_data_id) this.setExternalUrl();
    },
  },

  methods: {
    ...mapActions('jStoreAutomation', ['getDetailAutomation']),
    ...mapActions('jStoreFormUi', ['actionGetDetailForm', 'actionGetDetailMultiForm', 'actionSetForm', 'actionSetMultiForm', 'actionGetDetailFormData']),
    ...mapMutations('jStoreFormUi', ['setChangesValueView']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),

    getListFunction() {
      const dataFilter = {
        company_id: this.session.user.company_id,
      };
      dataFilter['trigger.type'] = 'function';
      const param = {
        limit: 1000000,
        page: 1,
        sort: { created_at: -1 },
        filter: JSON.stringify(dataFilter),
      };
      this.getDetailAutomation(param).then((res) => {
        this.listFunction = res.data.data.map(e => ({
          id: e.trigger.function ? e.trigger.function.name : '',
          name: e.trigger.function ? e.trigger.function.name : '',
        }));
      });
    },

    setDefaultConfigField(dataSource) {
      const { text_1, text_2, text_3, text_4 } = dataSource || this.dataSetup;
      const datas = [text_1, text_2, text_3, text_4];

      if (!this.dataSetup.config.columns) this.dataSetup.config.columns = [];
      if (this.dataSetup.config.columns.length === 0) {
        datas.forEach((data, index) => {
          if (data) {
            this.dataSetup.config.columns.push({
              field: `text_${index + 1}`,
              key: data,
              type: 'text',
            });
          }
        });
      }
    },

    openModalTitle(status) {
      if (this.isOpenModalField) this.toggleModalField(false);
      if (this.isOpenConfiguration) this.toggleConfiguration(false);
      if (this.isOpenConfigBlock) this.toggleConfigurationBlock(false);

      this.toggleModalTitle(status);
    },

    toggleModalTitle(status) {
      if (status) {
        this.isOpenModalTitle = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalTitle);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalTitle);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalTitle = false;
        }, 200);
      }
    },

    submitModalTitle(data) {
      this.dataSetup.title = data;
      this.toggleModalTitle(false);
      this.setChangesValueView(true);
    },

    openModalField(field) {
      if (this.isOpenModalTitle) this.toggleModalTitle(false);
      if (this.isOpenConfiguration) this.toggleConfiguration(false);
      if (this.isOpenConfigBlock) this.toggleConfigurationBlock(false);

      if (this.isOpenModalField) {
        this.toggleModalField(false);
        setTimeout(() => {
          let data = null;

          if (field === 'icon') {
            data = {
              field,
              url: this.dataSetup.urlImg,
            };
          } else {
            const checkConfig = !!this.dataSetup.config.columns.length > 0;
            const index = checkConfig ? this.dataSetup.config.columns.findIndex(column => column.field === field) : -1;
            const timezone = this.dataSetup.config.columns[index] && this.dataSetup.config.columns[index].timezone ?
              this.dataSetup.config.columns[index].timezone
              : null;

            data = {
              field,
              type: index !== null && index !== -1 ? this.dataSetup.config.columns[index].type : null,
              variable: this.dataSetup[field],
              timezone,
            };
            this.selectedIndexConfigField = index;
          }
          this.selectedField = data;
          this.toggleModalField(true);
        }, 200);
      } else {
        let data = null;

        if (field === 'icon') {
          data = {
            field,
            url: this.dataSetup.urlImg,
          };
        } else {
          const checkConfig = !!this.dataSetup.config.columns.length > 0;
          const index = checkConfig ? this.dataSetup.config.columns.findIndex(column => column.field === field) : -1;
          const timezone = this.dataSetup.config.columns[index] && this.dataSetup.config.columns[index].timezone ?
            this.dataSetup.config.columns[index].timezone
            : null;

          data = {
            field,
            type: index !== null && index !== -1 ? this.dataSetup.config.columns[index].type : null,
            variable: this.dataSetup[field],
            timezone,
          };
          this.selectedIndexConfigField = index;
        }
        this.selectedField = data;
        this.toggleModalField(true);
      }
    },

    toggleModalField(status) {
      if (status) {
        this.isOpenModalField = true;
        setTimeout(() => {
          const element = document.getElementById(this.idModalField);
          if (element) element.classList.add('show');
        }, 200);
      } else {
        const element = document.getElementById(this.idModalField);
        if (element) element.classList.remove('show');

        setTimeout(() => {
          this.isOpenModalField = false;
          this.selectedField = null;
          this.selectedIndexConfigField = null;
        }, 200);
      }
    },

    submitModalField(params) {
      if (this.selectedField.field !== 'icon') {
        const timeZone = params.timezone || null;
        if (timeZone) {
          delete timeZone.id;
          delete timeZone.label;
        }
        this.dataSetup[this.selectedField.field] = params.variable;

        if (this.selectedIndexConfigField > -1) {
          this.dataSetup.config.columns[this.selectedIndexConfigField] = {
            field: this.selectedField.field,
            key: params.variable,
            type: params.type,
            timezone: timeZone,
          };
        } else if (this.selectedIndexConfigField === -1) {
          this.dataSetup.config.columns.push({
            field: this.selectedField.field,
            key: params.variable,
            type: params.type,
            timezone: timeZone,
          });
        }
      } else {
        this.dataSetup.urlImg = params.url;
      }
      this.toggleModalField(false);
      this.setChangesValueView(true);
    },

    deleteField(field) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this field ?',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D0021B',
        cancelButtonColor: '#606060',
        titleColor: '#676767',
      }).then(async (result) => {
        if (result.value) {
          if (field === 'icon') {
            this.dataSetup.urlImg = null;
          } else {
            const checkConfig = !!this.dataSetup.config.columns.length > 0;
            const index = checkConfig ? this.dataSetup.config.columns.findIndex(column => column.key === this.dataSetup[field]) : null;

            this.dataSetup[field] = null;
            this.dataSetup.config.columns.splice(index, 1);
          }
        }
      });
    },

    openConfiguration() {
      if (this.isOpenModalTitle) this.toggleModalTitle(false);
      if (this.isOpenModalField) this.toggleModalField(false);
      if (this.isOpenConfigBlock) this.toggleConfigurationBlock(false);

      this.isOpenConfiguration = true;
      this.toggleConfiguration(true);
    },

    toggleConfiguration(status) {
      if (status) {
        setTimeout(() => {
          const element = document.getElementById(this.idConfiguration);
          if (element) element.classList.add('show-properties-field');
        }, 200);
      } else {
        const element = document.getElementById(this.idConfiguration);
        if (element) element.classList.remove('show-properties-field');

        setTimeout(() => {
          this.isOpenConfiguration = false;
        }, 200);
      }
    },

    submitConfig(params, type) {
      this.dataSetup.title = params.title;
      this.dataSetup.sorting = params.sorting;
      this.dataSetup.filter = params.filter;
      this.dataSetup.filter_function = params.filter_function;
      this.dataSetup.filterOperator = params.filterOperator;
      this.dataSetup.search_options_list = params.search_options_list;

      if (type === 'requestor' || type === 'approver') {
        this.dataSetup.isHideCheckbox = params.isHideCheckbox;
      }

      this.setChangesValueView(true);
      this.toggleConfiguration(false);
    },

    closeModalFieldLibrary(data) {
      const element = document.getElementById(this.idModalFieldLibrary);
      if (element) element.classList.remove('show');

      if (this.isShowModalFieldFromGroup) {
        if (data) this.setSourceModalFieldLibrary(data);
      }

      setTimeout(() => {
        this.setShowModalFieldLibrary(false);
        this.setIsShowModalFieldFromGroup(false);
      }, 300);
    },

    async submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        this.$swal({
          title: 'Update',
          text: `Are you sure to update ${this.formDetail.name}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Update',
          confirmButtonColor: '#42a5ce',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then(async (result) => {
          if (result.value) {
            let res;
            if (!this.isMultipleForm) {
              res = await this.actionSetForm(this.genData);
            } else {
              res = await this.actionSetMultiForm(this.genData);
            }
            if (!res.error) {
              this.setChangesValueView(false);
              const dataFilter = {
                id: [this.$route.params.id],
              };
              const param = {
                limit: 0,
                page: 1,
                filter: JSON.stringify(dataFilter),
              };
              if (!this.isMultipleForm) {
                await this.actionGetDetailForm(param);
              } else {
                await this.actionGetDetailMultiForm(param);
              }
            }
          }
        });
      }
      if (this.$v.dataSetup.$error) {
        this.toggleProblem('Please completed the required Configuration');
      }
    },

    async deleteView(type) {
      this.$swal({
        title: 'Delete',
        text: 'Are you sure to delete this view?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const params = this._.cloneDeep(this.formDetail);
          if (type === 'default') params.list_view = null;
          else if (type === 'requestor') params.list_requester_view = null;
          else if (type === 'approver') params.list_approver_view = null;

          let res;
          if (!this.isMultipleForm) {
            res = await this.actionSetForm(params);
          } else {
            res = await this.actionSetMultiForm(params);
          }
          if (!res.error) {
            this.setChangesValueView(false);
            const dataFilter = {
              id: [this.$route.params.id],
            };
            const param = {
              limit: 0,
              page: 1,
              filter: JSON.stringify(dataFilter),
            };
            if (!this.isMultipleForm) {
              await this.actionGetDetailForm(param);
            } else {
              await this.actionGetDetailMultiForm(param);
            }
            this.toggleConfiguration(false);
          }
        }
      });
    },

    sortConfig(data) {
      data.columns.sort((a, b) => a.field.localeCompare(b.field));
      return data;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixSetupListView.js